import EditMicroserviceModal from "./EditMicroserviceModal";

export default EditMicroserviceModal;